import ContentBoxBackgroundContent from 'components/ContentBoxBackgroundContent'
import TextBody from 'components/TextBody'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'
import React from 'react'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { defineMessages } from 'react-intl'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import useIntl from 'modules/component/utils/hooks/useIntl'
import ButtonPrimary from 'components/ButtonPrimary/index.js'
import { View } from 'components/View.js'
import logEventAnalyticsUtil from 'modules/analytics/utils/log-event/index.js'

const TIMER_IN_MS = 7000 // 7 seconds

const messages = defineMessages({
  loading: {
    id: 'PageLoader.loading',
    defaultMessage: 'Loading...'
  },
  itsTakingTooLongToLoad: {
    id: 'PageLoader.itsTakingTooLongToLoad',
    defaultMessage: 'It’s taking too long to load, please try to refresh the page to resolve this issue.'
  },
  refreshThePage: {
    id: 'PageLoader.refreshThePage',
    defaultMessage: 'Refresh the page'
  }
})

const ANALYTIC_EVENT = {
  SHOW_PAGE_LOADER_REFRESH: 'SHOW_PAGE_LOADER_REFRESH',
  PAGE_LOADER_REFRESH: 'PAGE_LOADER_REFRESH'
}

/**
 * @param hasNoMargin
 * @returns {JSX.Element}
 * @constructor
 */
export const PageLoader = ({ hasNoMargin }) => {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const intl = useIntl()
  const [shouldShowRefresh, setShouldShowRefresh] = React.useState(false)
  const timerIdRef = React.useRef(null)

  React.useEffect(() => {
    timerIdRef.current = setTimeout(() => {
      setShouldShowRefresh(true)
      logEventAnalyticsUtil(ANALYTIC_EVENT.SHOW_PAGE_LOADER_REFRESH)
    }, TIMER_IN_MS)

    return () => {
      if (timerIdRef.current) {
        clearTimeout(timerIdRef.current)
      }
    }
  }, [])

  const handlePressRefreshThePage = () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT.PAGE_LOADER_REFRESH)
    if (timerIdRef.current) {
      clearTimeout(timerIdRef.current)
    }
    window.location.reload()
  }

  return (
    <ContentBoxBackgroundContent
      style={{
        margin: isSmallScreen && !hasNoMargin
          ? `${STYLES_MARGIN.BIGGER} ${STYLES_MARGIN.BIG}`
          : `${STYLES_MARGIN.MEDIUM}`
      }}
    >
      {
        shouldShowRefresh
          ? (
            <View>
              <TextBody>
                {formatMessageIntlUtil(intl, messages.itsTakingTooLongToLoad)}
              </TextBody>

              <View mt={2}>
                <ButtonPrimary onClick={handlePressRefreshThePage}>
                  {formatMessageIntlUtil(intl, messages.refreshThePage)}
                </ButtonPrimary>
              </View>
            </View>
            )
          : (
            <TextBody>
              {formatMessageIntlUtil(intl, messages.loading)}
            </TextBody>
            )
      }
    </ContentBoxBackgroundContent>
  )
}
